<template>
  <el-drawer
  :title="title"
  :visible.sync="visible"
  direction="rtl"
  :v-loading="loading"
  :before-close="handleClose"
  :wrapperClosable="false"
  :modal-append-to-body="false"
  :size="width"
  @open="open">
  <!-- <div class="drawer__content scrollable only-y" :style="divHeight" ></div> -->
  <div class="drawer__content scrollable only-y mb-50" >
    <el-form :rules="rules" ref="reservationForm" :model="model" label-position="top">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('reservation.customer')" prop="customer" :required="true">
            <CustomerSelectComponent
              :customer="model.customer"
              :active="true"
              :disabled="!isCustomerEditable"
              @selected="setCustomerModel">
            </CustomerSelectComponent>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('reservation.salesRep')" prop="rep" >
              <el-select v-model="model.salesRep" value-key="id">
                  <el-option
                    v-for="user in filterUserWithRoleRep"
                    :key="user.id"
                    :label="user.firstName + ' ' + user.lastName"
                    :value="user">
                  </el-option>
                </el-select>
              </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item :label="$t('reservation.contact')" prop="selectedContacts">
            <el-select
              v-model="model.selectedContacts"
              multiple
              value-key="id">
              <el-option
                v-for="contact in contacts"
                :key="contact.id"
                :label="labelContact(contact)"
                :value="contact">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="edit==null">
        <el-col>
          <el-form-item :label="$t('reservation.selectProduct')">
            <el-autocomplete class="inline-input" v-model="productSelected" style="width:100%;" :fetch-suggestions="querySearch" @select="handleSelect">
              <template slot-scope="{ item }">
                <ItemTemplate :product="item" :quantity="item.quantity" :inventory="item.inventory"></ItemTemplate>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider/>
      <div v-if="isIntentEdition === true">
            <el-row >
              <h4>{{$t('reservation.convertIntentTo')}}</h4>
              <div style="margin-top: 20px">
                <el-checkbox-group v-model="convertTo" size="small" @change="handleConversionMethod">
                   <el-checkbox label="available" border>{{$t('reservation.onAvailableProduct')}} ({{nbIntentProductsAvailable}})</el-checkbox>
                   <el-checkbox label="toCome" border>{{$t('reservation.onProductToCome')}} ({{nbIntentProductsDelayedAvailable}})</el-checkbox>
                 </el-checkbox-group>
                <!-- <el-radio v-model="convertTo" size="small" label="available" border :disabled="model.details[index].productAvailable != true">Réservation sur produit disponible ({{nbIntentProductsAvailable}})</el-radio> -->
                <!-- <el-radio v-model="convertTo" size="small" label="toCome" border :disabled="model.details[index].productToComeAvailable != true">Réservation sur produit à venir ({{nbIntentProductsDelayedAvailable}})</el-radio> -->
              </div>
            </el-row>
            <h5 v-if="conversion != null && (nbIntentProductsDelayedAvailable > 0 || nbIntentProductsAvailable > 0)"> {{$t('reservation.chosseProduct')}} </h5>
            <el-row v-if="conversion === 'available' && realNbIntentProductsAvailable === 0">
              <el-col>
                <div class="p-20 m-10 danger-text text-center">{{ $t('reservation.conversionToAvailableProductImpossible') }}</div>
              </el-col>
            </el-row>
            <el-row v-if="conversion === 'toCome' && realNbIntentProductsDelayedAvailable === 0">
              <el-col>
                <div class="p-20 m-10 danger-text text-center">{{ $t('reservation.conversionToProductToComeImpossible') }}</div>
              </el-col>
            </el-row>
            <el-row class="mt-10" v-if="conversion === 'available'" >
              <el-row v-for="(pa, index) in intentProductsAvailable" :key="pa.puid">
                <el-col>
                <ItemTemplate
                  :class="{ 'border card-shadow--small bg-accent-lighter': pa.puid === selectedPuid, 'selectable': isIntentProductsSelectable[index], 'notSelectable bg-white danger-text': !isIntentProductsSelectable[index]  }"
                  class="p-10"
                  @click="v => handleSelectAvailableProduct(v, index)"
                  :product="pa"
                  :quantity="pa.quantity"
                  :inventory="pa.inventory" />
                </el-col>
              </el-row>
            </el-row>
            <el-row class="mt-10" v-if="conversion === 'toCome'" >
              <el-row v-for="(pa, index) in intentProductsDelayedAvailable" :key="pa.puid">
                <el-col>
                  <el-tooltip class="item" effect="dark" :content="$t('reservation.insufficientQuantity')" placement="top" :disabled="isIntentProductsDelayedSelectable[index]">
                    <ItemTemplate
                      :class="{ 'border card-shadow--small ': pa.puid === selectedPuid, 'bg-accent-lighter': isIntentProductsDelayedSelectable[index], 'notSelectable bg-white danger-text': !isIntentProductsDelayedSelectable[index]  }"
                      class="p-10 "
                      @click="v => handleSelectDelayedProduct(v, index)"
                      :product="pa"
                      :quantity="pa.quantity"
                      :inventory="pa.inventory" />
                    </el-tooltip>
                </el-col>
              </el-row>
            </el-row>
            <el-divider/>
          </div>
      
      <div style="padding:10px;">
        <div v-for="(detail, index) in model.details" :key="index" class="box-card">
          <div style="height:40px;" v-if="!editionMode">
            <el-button  style="float: right;" icon="el-icon-close" :underline="false" @click="removeItemLine(index)">Retirer le produit</el-button>
          </div>
          <el-row class="mt-10 mb-10">
            <el-form-item :label="$t('reservation.product')" :required="true">
              <template slot="error" slot-scope="scope">
                    <span style="color:#ec205f;"><i class="el-icon-warning" style="margin-left:5px;"></i> {{$t('reservations.errors.' + scope.error)}}</span>
              </template>
              <div style="line-height:20px;" class="p-10 card-shadow--small ml-0">
                  <i class="mdi mdi-barcode-scan" v-if="detail.product.type==1" style="font-size:18px;margin-right:5px;color: grey;"></i>
                  <span>{{detail.product.extendedName || detail.product.name}}</span><br>
                  <span class="fs-14 secondary-text">SKU : {{detail.product.sku}}</span><br>
                  <span class="fs-14 secondary-text"><UnitFormatVolumeLabel :unit="detail.product.unit" :uvc="detail.product.uvc" :format="detail.product.format" :volume="detail.product.volume"></UnitFormatVolumeLabel></span> <br>
                  <span class="fs-14 secondary-text" v-if="detail.product.selling_unit_price">{{$n(detail.product.selling_unit_price,'currency')}}<br></span>
                  <span class="fs-14 secondary-text" v-if="detail.intent === false && detail.product.quantity != null && detail.product.quantity.inStock>=0">{{$t('reservation.availableQuantity')}} {{detail.product.quantity.inStock}}</span>
                  <span class="fs-14 secondary-text" v-else >{{ $t('reservation.availableQuantity') }} 0</span>
                  <br><span class="fs-14 secondary-text" v-if="detail.intent === false && detail.product.quantity != null">{{$t('reservation.quantityInSupply')}} <span v-if="detail.product.quantity.pending - detail.product.quantity.reservedDelayed >= 0">{{detail.product.quantity.pending - detail.product.quantity.reservedDelayed}}</span><span v-else>0</span></span>
                </div>
            </el-form-item>
          </el-row>
          <el-row class="mb-10" justify="center" v-if="isIntentEdition === false">
            <el-form-item :label="$t('reservation.reservationType')" :required="true">
              <el-radio-group v-model="model.details[index].type" size="small" @change="handleTypeChange">
                 <el-tooltip class="item" :disabled="model.details[index].productAvailable === true === true" effect="dark" :content="$t('reservation.productNotAvailable')" placement="top">
                   <el-radio-button label="PRODUCT_AVAILABLE" :disabled="model.details[index].productAvailable == false || (detail.intent === true && model.id != null)">{{$t('reservation.availableProduct')}}</el-radio-button>
                  </el-tooltip>
                  <el-tooltip class="item" :disabled="model.details[index].productToComeAvailable" effect="dark" :content="$t('reservation.productNotToComme')" placement="top">
                    <el-radio-button label="PRODUCT_TO_COME" :disabled="model.details[index].productToComeAvailable == false || (detail.intent === true && model.id != null)">{{$t('reservation.productToCome')}}</el-radio-button>
                   </el-tooltip>
                   <el-radio-button label="INTENT">{{$t('reservation.purchaseIntent')}}</el-radio-button>
               </el-radio-group>
             </el-form-item>
          </el-row>
          <el-row>
              <el-col :xs="24" :sm="24" :md="8" :lg="10" :xl="10">
                <el-form-item :label="$t('reservation.quantity')" :required="true">
                  <el-tooltip class="item" :disabled="edit == null" effect="dark" :content="$t('reservation.remianingQuantityReservation')" placement="top-start">
                    <unitQuantities
                      @change="v => setQtyOrdered(index, v)"
                      :disabled="detail.invalid && !editionMode"
                      :default="quantityAvailable || detail.product.uvc || 1"
                      :product_unit="detail.product.unit"
                      :product_uvc="detail.product.uvc"
                      :default_unit="1" />
                  </el-tooltip>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="model.details[index].type === 'PRODUCT_AVAILABLE' && !isIntentEdition">
            <el-form-item style="margin-right:10px;" :label="$t('reservation.date')" :required="true">
              <el-date-picker
                v-model="model.details[index].date"
                type="date">
              </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-right:10px;">
              <el-checkbox v-model="model.details[index].limitDateActivated" @change="v => handleActivate(v, index)">Activer la date limite</el-checkbox>
              </el-form-item>
            <el-form-item style="margin-right:10px;" :label="$t('reservation.limitDate')">
              
              <el-date-picker
                :disabled="model.details[index].limitDateActivated === false"
                v-model="model.details[index].limitDate"
                type="date">
              </el-date-picker>
              <span class="fs-10 ml-5">{{$t('reservation.limitDateDefault')}}</span>
            </el-form-item>
            
          </el-row>
          <el-row>
            <el-form-item style="margin-right:10px;" :label="$t('reservations.Commentaries')" >
              <el-input type="textarea" :rows="2" v-model="model.details[index].comment"></el-input>
            </el-form-item>
          </el-row>
          <!-- <el-divider/> -->
        </div>
      </div>
    </el-form>
    <div class="dialog-footer card-shadow--large">
      <el-button @click="handleClose">{{ $t('common.Cancel') }}</el-button>
      <el-button type="primary" @click="save" :disabled="loading">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</el-drawer>
</template>
<script>
import ItemTemplate from '@/components/product/item-template-v2'
import unitQuantities from '@/components/product/unit-quantities-horizontal';
import CustomerSelectComponent from '@/components/customer/select-customer-autocomplete'
import customerUtil from '@/utils/customer-util.js'
import { mapActions, mapState, mapGetters } from 'vuex';
import inventoryAPI from '@/services/API/inventory'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import customerAPI from '@/services/API/customer'
import reservationAPI from '@/services/API/reservation'
import SelectInventory from '@/components/inventory/select-inventory'
import dayJs from 'dayjs';
export default {
  name: 'Reservation-Editor',
	props: {
    customerId : {
      type : String,
      default : null
    },
    product : {
      type : Object,
      default : null
    },
    visible : {
      type : Boolean,
      default : false
    },
    edit : null
	},
  data() {
    var validateFollowUpContact = (rule, value, callback) => {
      if ((value == null || value.length === 0) && _.size(this.contactsWithReservationOrdersInd) === 0) {
        callback(new Error('Vous devez spécifier au moins un contact responsable.'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      loadingCustomer: false,
      productSelected : null,
      searchTimeOut: null,
      convertTo: [],
      convertedProduct: null,
      productsAvailable: [],
      lineModel : {
        id : null,
        product: null,
        puid: null,
        qty: null,
        type: null,
        delayed: false,
        intent: false,
        comment: null,
        quantity: null,
        limitDate: null,
        date : null,
        limitDateActivated: false,
      },
      customers : [],
      model : {
        inventory: null,
        details: [],
        salesRep: null,
        customer: null,
        selectedContacts: [],
      },
      contacts : [],
      window: {
        width: 0,
        height: 0
      },
      rules : {
        selectedContacts : [
          {
            validator: validateFollowUpContact, trigger: 'blur',
          }
        ],
        type : [
  	  		 	{ required: true, message: 'Veuillez saisir un type de réservation.', trigger: 'blur' }
  	  		],
      }
    };
  },components: {
    ItemTemplate,
    unitQuantities,
    CustomerSelectComponent,
    UnitFormatVolumeLabel,
    SelectInventory
  },
  watch : {

  },
	methods: {
    activateDelayOnReservation(v, index) {
      this.model.details[index].limitDate = dayJs(_.get(this.model.details[index], 'product.item.availabilityDate')).add(150, 'day').format('YYYY-MM-DD');
      this.model.details[index].limitDateActivated = true;
    },
    deactivateDelayOnReservation(index) {
      this.model.details[index].limitDate = null;
    },
    handleActivate(v, index) {
      if (v === true) {
        if (_.get(this.model.details[index], 'product.inventory.code') === 'IP') {
          this.activateDelayOnReservation(v, index)
        } 
      } else {
          this.deactivateDelayOnReservation(index);
        }
    },
    handleConversionMethod () {
      this.convertedProduct = null;
      if (_.size(this.convertTo) > 1) {
        this.convertTo.splice(0,1);
      }

      if (this.conversion === 'available' && this.nbIntentProductsAvailable === 1 && this.isIntentProductsSelectable[0] === true) {
        this.convertedProduct = _.head(this.intentProductsAvailable);
      }else if (this.conversion === 'toCome' && this.nbIntentProductsDelayedAvailable === 1 && this.isIntentProductsDelayedSelectable[0] === true) {
          this.convertedProduct = _.head(this.intentProductsDelayedAvailable);
      }
    },
    handleSelectDelayedProduct (v, index){
      if (this.isIntentProductsDelayedSelectable[index]) {
        this.convertedProduct = v;
      }

    },
    handleSelectAvailableProduct (v, index){
      if (this.isIntentProductsSelectable[index]) {
        this.convertedProduct = v;
      }

    },
    handleTypeChange(){
      this.validateDetails();
    },
    validateDetails(){
      this.loading = true;
      _.forEach(this.model.details, (detail) => {
        detail.delayed = detail.type === 'PRODUCT_TO_COME';
        detail.intent = detail.type === 'INTENT';
      })
      return reservationAPI.validateV2(this.model)
        .then(validatedReservationDetails => {
          _.forEach(validatedReservationDetails, line=>{
            let storeDetailLine = _.find(this.model.details, item=>{return item.product.id==line.product.id});
            line.productAvailable = _.get(line, 'product.quantity.inStock') > 0;
            line.productToComeAvailable = _.get(line, 'product.quantity.pending') > 0;
            this.productsAvailable = line.productsAvailable;
            // Gestion de la disponibilité des produits lorsque c'est un intentino d'achat
            if (_.size(this.productsAvailable) === 1) {
              line.product = _.head(this.productsAvailable);
              line.puid = _.get(line, 'product.puid');
              line.productAvailable = _.get(line, 'product.quantity.inStock') > 0;
              line.productToComeAvailable = _.get(line, 'product.quantity.pending') > 0;
            } else if (_.size(this.productsAvailable) > 1){
              let productAvailable = false;
              let productToComeAvailable = false;
              _.forEach(this.productsAvailable, (p) => {
                if (_.get(p, 'quantity.inStock') > 0) {
                  productAvailable = true;
                }
                if (_.get(p, 'quantity.pending') > 0) {
                  productToComeAvailable = true;
                }
              })
              line.productAvailable = productAvailable;
              line.productToComeAvailable = productToComeAvailable;

            }


            if(line.delayed==="true"||line.delayed==true){
              line.delayed=true;
            }else{
              line.delayed=false;
            }


            Object.assign(storeDetailLine, line);
            this.loading = false;
          })
        })
    },
    cloneReservation (reservation) {
      let clone = _.cloneDeep(reservation);
      this.model.salesRep = clone.sales_rep!=null ? clone.sales_rep : null;
      this.model.qty = clone.quantity;
      this.model.selectedContacts= clone.follow_up_contacts;
      this.model.id=clone.id;
      this.model.quantity = clone.quantity;
      let detailLine = {};
      detailLine.availableQty = clone.availableQty;
      detailLine.product = clone.product;
      detailLine.intent = clone.intent;
      detailLine.delayed = clone.delayed;
      detailLine.puid = clone.puid;
      detailLine.limitDateActivated = false;
      detailLine.limitDate = clone.limit_date;
      if (detailLine.limitDate != null) {
        detailLine.limitDateActivated = true;
      }

      detailLine.type = "PRODUCT_AVAILABLE";
      if (detailLine.delayed === true) {
        detailLine.type = 'PRODUCT_TO_COME';
      } else if (detailLine.intent === true) {
        detailLine.type = 'INTENT';
      } else {
        detailLine.date = clone.date;
      }
      detailLine.product.quantity = detailLine.product.quantities[0];
      detailLine.product.quantities = null;
      detailLine.comment = clone.comment;
      delete detailLine.product.quantities;
      detailLine.qty=clone.qty;

      this.model.details.push(detailLine);
    },
    fetchCustomer (customerId) {
      return customerAPI.getCustomer(customerId);
    },
    fetchCustomers (customerId) {
      this.loadingCustomer = true;
      return customerAPI.fetchSearchedCustomers({ paging:'no',customerId: parseInt(customerId) })
      .then((customers) => {
        this.customers = customers;
      })
    },
    addLine (product, structure = 'V1') {
      this.loading = true;

      //On chercher si ou avons deja mis ce produit dans notre réservation
      let lineFoundWithProductID = _.find(this.model.details, detail=>{
        return detail.product.id == product.id;
      })

      if (lineFoundWithProductID == null) {
        if(structure === 'V1') { //Format V1
          let newLine = _.cloneDeep(this.lineModel);
          newLine.date = new Date();
          if(product.id){
            newLine.product = _.cloneDeep(product);
            newLine.product.quantity = _.cloneDeep(product.quantities[0]);
          }else{
            newLine.product = _.cloneDeep(product.product);
            let quantity = _.cloneDeep(product);
            quantity.product = null;
            delete quantity.product;
            newLine.product.quantity = quantity;
          }
          newLine.converteProduct = null;
          newLine.productsAvailable = [];
          newLine.qty = newLine.product.uvc != null ? newLine.product.uvc : 1;
          newLine.type = "PRODUCT_AVAILABLE";
          newLine.productAvailable = _.get(newLine, 'product.in_stock') > 0;
          newLine.productToComeAvailable = _.get(newLine, 'product.pending') > 0;
          if (_.get(product, 'in_stock') == 0 && _.get(product, 'pending') > 0) {
            newLine.type = 'PRODUCT_TO_COME';
          } else if (_.get(product, 'in_stock') == 0 && _.get(product, 'pending') == 0) {
            newLine.type = 'INTENT';
          }
          newLine.delayed = _.get(product, 'in_stock') === 0 && _.get(product, 'pending') > 0;
          newLine.intent = _.get(product, 'in_stock') === 0 && _.get(product, 'pending') === 0;
          newLine.comment = null;
          newLine.puid = product.puid;
          if (this.isAutomaticDelayOnReservationActivated === true && newLine.type != 'INTENT' &&  newLine.type != 'PRODUCT_TO_COME') {
            newLine.limitDateActivated = true;
          }
          this.model.details.push(newLine);
          this.validateDetails();
        } else { //Format V2
          let newLine = _.cloneDeep(this.lineModel);
          newLine.id = product.id;
          newLine.date = newLine.date = new Date();
          newLine.product = _.cloneDeep(product);
          newLine.qty = product.uvc != null ? product.uvc : 1;
          newLine.productAvailable = _.get(product, 'quantity.inStock') > 0;
          newLine.productToComeAvailable = _.get(product, 'quantity.pending') > 0;
          newLine.type = "PRODUCT_AVAILABLE";
          let availabilityDate = null;
          if (_.get(product, 'quantity.inStock') === 0 && _.get(product, 'quantity.pending') > 0) {
            newLine.type = 'PRODUCT_TO_COME';
          } else if (_.get(product, 'quantity,inStock') == 0 && _.get(product, 'quantity.pending') == 0) {
            newLine.type = 'INTENT';
          } else {
            // on regarde si l'inventaire est IP. si oui alors on calcul une date limit de 150 jours aprèes la date de mise en disponiblité.
            if (_.get(product, 'inventory.code') === 'IP') {
              availabilityDate = _.get(product, 'item.availabilityDate');
            }
            
          }
          newLine.product.quantity = product.quantity;
          // newLine.product.quantity = {
          //   in_stock: _.get(product, 'quantity.inStock'),
          //   pending: _.get(product, 'quantity.pending'),
          //   reserved_new_shipement: _.get(product, 'quantity.reservedDelayed'),
          //   fk_inventory_id : _.get(product, 'inventory.id'),
          // };
          newLine.delayed = _.get(product, 'quantity.inStock') === 0 && _.get(product, 'quantity.pending') > 0;
          newLine.intent = _.get(product, 'quantity.inStock') === 0 && _.get(product, 'quantity.pending') === 0;
          newLine.comment = null;
          newLine.puid = product.puid;
          if (availabilityDate != null) {
            newLine.limitDate = dayJs(availabilityDate).add(150, 'day').format('YYYY-MM-DD');
          }
          
          if (this.isAutomaticDelayOnReservationActivated === true && newLine.type != 'INTENT' &&  newLine.type != 'PRODUCT_TO_COME') {
            newLine.limitDateActivated = true;
          }
          
          this.model.details.push(newLine);
          this.validateDetails();
        }

        if (this.isAutomaticDelayOnReservationActivated === true && newLine.type != 'INTENT' &&  newLine.type != 'PRODUCT_TO_COME') {
          this.activateDelayOnReservation(_.last(this.model.details), 0);
        }

      } else {
        this.$message({
            message: "Le produit a déjà été sélectionné.",
            type: 'warning'
          });
      }
    },
    setInventoryModel (inventory) {
      this.model.inventory = inventory;
    },
    setCustomerModel (customer) {
      this.model.customer = customer;
      if (this.model.customer != null && this.model.customer.id != customer.id) {
        this.model.selectedContacts = [];
      }
      
      if (customer != null && customer.rep != null) {
        this.model.salesRep = customer.rep;
      }
      // BUGFIX : Il faut filter sur les contacts qui sont toujours actifs.
      this.contacts = _.filter(_.get(customer, 'company.contacts'), c => _.get(c, 'company_user.active') == true);
      if (customer.company != null && _.size(this.contacts) === 1) {
        this.model.selectedContacts = this.contacts;
      }

      return this.model.customer;
    },
    labelContact(contact){
      return contact.first_name + " " + contact.last_name;
    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    fetchProducts(query){
      if (query ==null || query === '') {
        return Promise.resolve([]);
      }
      return reservationAPI.fetchProductsReservation({ searchTerms:query });
    },
    querySearch(queryString, cb){
      if (queryString == null) return [];
      else {
        this.searchTimeOut = setTimeout(() => {
        this.fetchProducts(queryString)
            .then((products) => {
              cb(products);
            })
        }, 1000)
      }
    },
    createFilter(queryString) {
      return (item) => {
          return (_.deburr(item.product.name).toLowerCase().indexOf(_.deburr(queryString).toLowerCase()) === 0);
      };
    },
    handleSelect(selectedItem){
      this.addLine(selectedItem, 'V2');
    },
    validateReservation(){
      return new Promise((resolve, reject) => {
        let errorCode = null;
        let valid  = true;
        _.forEach(this.model.details, detail=>{
          if (detail.type == null) {
            valid = false;

          }

          if(detail.invalid){
            valid = false;
          }
          if(detail.errors){
            errorCode = detail.errors.jse_info.errorCode;
            valid = false;
          }
        });

        return resolve(valid);
      });
    },
    save(){
      this.loading = true;
      let saveFunction=this.editionMode?this.updateReservation:this.saveNewReservation;

      this.$refs['reservationForm'].validate((valid)=>{

        this.validateReservation()
          .then(reservationValid=>{
            if(valid && reservationValid){
              saveFunction()
                .then(reservation=>{
                  if(!this.editionMode){
                    this.$emit('created');
                  }else{
                    this.$emit('updated',reservation);
                  }
                  this.loading = false;
                  this.handleClose();
                  this.$message({
                    message: "La réservation a été sauvegardée avec succès!",
                    type: 'success'
                  });
                })
                .catch((err) => {
                  this.loading = false;
                  console.log(err);
                })

            }else{
              this.loading = false;
              if(valid && this.model.details.length==0){
                this.$notify({
                    title: 'Avertissement',
                    message: "Vous devez ajouter au moins un produit à votre réservation",
                    type: 'warning'
                  });
              }else{
                this.$notify({
                    title: 'Avertissement',
                    message: "Certains champs obligatoires n'ont pas été renseignés ou le formulaire comporte des erreurs.",
                    type: 'warning'
                  });
              }
            }
          });
          })

    },
    setQtyOrdered(index,qty){
      let qtyToSet = qty;

      if (this.edit != null) {
        qtyToSet += this.edit.quantity.qty_used;
      }
      this.model.details[index].qty = qtyToSet;
      this.validateDetails();
    },
    setReservationType(index, type){
      this.setReservationType({ index:0, type:'INTENT' });
    },
    reset(){
      this.model.id = null;
      this.model.details = [];
      this.model.salesRep = null;
      this.model.customer = null;
      this.model.selectedContacts = [];
      this.convertTo = [];
      this.product = null;
    },
    handleClose(){
      this.$refs['reservationForm'].resetFields();
      this.reset();

      this.$emit('close');
    },
    open(){
      this.model.customer = null;
      this.loading = true;
      // this.fetchAdminUsers();
      this.model.selectedCustomer = this.edit!=null ? this.edit.customer : null;

      if (this.product != null) {
        this.addLine(this.product, 'V2');
        
      }

      if (this.edit == null) {
        if (this.customerId != null) {
          this.fetchCustomer(parseInt(this.customerId))
            .then((customer) => {
              this.model.customer = customer;

              this.customers = [customer];
              this.contacts = _.get(customer, 'company.contacts');
              this.model.salesRep = _.get(customer, 'rep');
            })
        }
        let loggedUser = JSON.parse(localStorage.user);
        let loggedUserRepRole = _.find(loggedUser.roles, role => { return role.role_name === "Rep" });
        if(loggedUserRepRole){
          this.model.salseRep = JSON.parse(localStorage.user)
          // dispatch('setNewReservationSalesRepId',{salesRepId : JSON.parse(localStorage.user).id});
        }
        this.loading = false;
      }else{
        this.fetchCustomer(this.edit.customer.id)
          .then((customer) => {
            this.model.customer = customer;
            this.customers = [customer];
            this.contacts = _.get(customer, 'company.contacts');
            this.cloneReservation(this.edit);
            return this.validateDetails();
          }).then(() => {
            this.loading = false;
          })
      }


    },
    isDelayedDisabled(detail){
      if(detail == null) return false;
      return detail.product.quantity.pending<=0 || detail.invalid || detail.delayedWarning!=null;
    },
    getLineError(index) {
      if (this.model.details.length > index) {
        if(this.model.details[index].errors != null){
          return _.get(this.model.details[index], 'errors.jse_info.errorCode');
        } else if (this.model.details[index].errorCode != null) {
          return this.model.details[index].errorCode;
        }
        return "";
      }

    },
    customerName(customer) {
      return customerUtil.customerName(customer.name, customer.usual_name);
    },
    removeItemLine(index) {
      this.model.details.splice(index,1);
    },
    saveNewReservation(){
      this.loading = true;
      let reservationsToCreate = [];
      _.forEach(this.model.details, item=>{
        let detailLine = {};
        detailLine.puid = item.puid;
        detailLine.product = item.product;
        detailLine.qty = item.qty;
        detailLine.customerId = this.model.customer.id;
        detailLine.salesRepId = _.get(this.model, 'salesRep.id');
        detailLine.delayed = item.type === 'PRODUCT_TO_COME';
        detailLine.intent = item.type === 'INTENT';
        detailLine.comment = item.comment;
        detailLine.selectedContacts = this.model.selectedContacts;
        detailLine.limitDate = null;
        if (item.type === 'PRODUCT_TO_COME' || item.type === 'INTENT') {
          detailLine.date = null;
          detailLine.limitDate = null;
        } else {
          if (item.limitDateActivated === true) {
            detailLine.limitDate = item.limitDate;
          }
        }
        reservationsToCreate.push(detailLine);
      })
      return reservationAPI.postReservation(reservationsToCreate)
        .then(()=>{
          this.loading = false;
        }).catch(err=>{
          this.$message({
              message: "La sauvegarde de la réservation a échoué. Veuillez réessayer plus tard.",
              type: 'error'
            });
        })
    },
    updateReservation(){
     
      let reservationsToUpdate = {};
      reservationsToUpdate.date = this.model.details[0].date;
      reservationsToUpdate.product = this.model.details[0].product;
      reservationsToUpdate.comment = this.model.details[0].comment;
      reservationsToUpdate.limitDate = this.model.details[0].limitDate;
      reservationsToUpdate.qty = this.model.details[0].qty;
      reservationsToUpdate.customerId = _.get(this.model, 'customer.id');
      reservationsToUpdate.salesRepId =_.get(this.model, 'salesRep.id');
      reservationsToUpdate.id = this.model.id;
      reservationsToUpdate.selectedContacts = _.get(this.model, 'selectedContacts');

      if (this.isIntentEdition === true && this.convertedProduct != null) {
        reservationsToUpdate.puid = this.convertedProduct.puid;
        reservationsToUpdate.product = this.convertedProduct;

        if (this.conversion === 'available') {
          reservationsToUpdate.intent = false;
          reservationsToUpdate.delayed = false;

          reservationsToUpdate.limitDate = dayJs(_.get(this.model.details[0], 'product.item.availabilityDate')).add(150, 'day').format('YYYY-MM-DD');
        } else if (this.conversion === 'toCome') {
          reservationsToUpdate.intent = false;
          reservationsToUpdate.delayed = true;
        }
      } else {
        reservationsToUpdate.intent = this.model.details[0].type === 'INTENT';
        reservationsToUpdate.delayed = this.model.details[0].type === 'PRODUCT_TO_COME';
      }

      if (reservationsToUpdate.intent === true || reservationsToUpdate.delayed === true) {
        reservationsToUpdate.date = null;
        reservationsToUpdate.limitDate = null;
      } 


      reservationsToUpdate.selectedContacts = _.get(this.model, 'selectedContacts');
      return reservationAPI.putReservation(reservationsToUpdate);
    },
    ...mapActions('users', ['fetchAdminUsers']),
	},
	computed: {

    isIntentEdition () {
      return _.get(this.edit, 'intent') === true;
    },
    conversion () {
      return _.head(this.convertTo);
    },
    selectedPuid () {
      return _.get(this.convertedProduct, 'puid');
    },
    isIntentProductsDelayedSelectable () {
      return _.map(this.intentProductsDelayedAvailable, p => (_.get(p, 'quantity.pending') - _.get(p, 'quantity.reservedDelayed') - this.model.details[0].qty) >= 0);
    },
    realNbIntentProductsDelayedAvailable () {
      return _.size(this.isIntentProductsDelayedSelectable);
    },
    nbIntentProductsDelayedAvailable () {
      return _.size(this.intentProductsDelayedAvailable);
    },
    intentProductsDelayedAvailable(){
      if (_.size(this.model.details) > 1) return [];
      if (_.get(this.model.details[0], 'intent') === false) return [];

      return _.filter(this.productsAvailable, p => _.get(p, 'quantity.pending') - _.get(p, 'quantity.reservedDelayed') > 0);
    },
    isIntentProductsSelectable () {
      return _.map(this.intentProductsAvailable, p => _.get(p, 'quantity.inStock') - _.get(_.head(this.model.details), 'availableQty') >= 0);
    },
    realNbIntentProductsAvailable () {
      return _.size(this.isIntentProductsSelectable);
    },
    nbIntentProductsAvailable () {
      return _.size(this.intentProductsAvailable);
    },
    intentProductsAvailable(){
      if (_.size(this.model.details) > 1) return [];
      if (_.get(this.model.details[0], 'intent') === false) return [];

      return _.filter(this.productsAvailable, p => _.get(p, 'quantity.inStock') > 0);
    },
    quantityAvailable(){
      if (this.edit == null) {
        return null;
      } else {
        if (this.edit.delayed == false && this.edit.intent == false) {
          // return this.edit.product.uvc != null ? this.edit.quantity.qty_available / this.edit.product.uvc : this.edit.quantity.qty_available;
          return this.edit.quantity.qty_available;
        } else {
          if (this.edit.quantity.qty_used > 0) {
            // return this.edit.product.uvc != null ? (this.edit.quantity.qty_reserved - this.edit.quantity.qty_used) / this.edit.product.uvc : this.edit.qty;
            return this.edit.quantity.qty_reserved - this.edit.quantity.qty_used;
          }
          // return this.edit.product.uvc != null ? this.edit.qty / this.edit.product.uvc : this.edit.qty;
          return this.edit.qty;
        }
      }
    },
    isCustomerEditable () {
      if (this.edit == null) return true;
      return (this.model.quantity != null &&
          this.model.quantity.qty_used ==0);

    },
    // contacts () {
    //   if(this.model.customer!=null){
    //     if(this.model.customer.company!=null){
    //       if (this.editionMode) {
    //         //REGLE A UTILISER LORSQUE UTILISATION AVEC V2
    //         return _.filter(this.model.customer.company.contacts, c=> c.active == true);
    //       }
    //       return _.filter(this.model.customer.company.contacts, c=> c.active === true && c.user_active === true);
    //     }else{
    //       return [this.model.customer.contact];
    //     }
    //   }else{
    //     return [];
    //   }
    // },
    title (){
      return this.edit == null ? this.$i18n.t('reservation.newReservation') : this.$i18n.t('reservation.editReservation');
    },
    maxEditQuantities () {
      if (this.edit != null) {
        return _.get(this.edit, 'quantity.qty_reserved') - _.get(this.edit, 'quantity.qty_used');
      }
      return 0;
    },
    minEditQuantities () {
      if (this.edit != null) {
        return _.get(this.edit, 'quantity.qty_used');
      }
      return 0;
    },
    contactsWithReservationOrdersInd(){
      if (this.model.customer ==null) return [];
      if (_.get((this.model, 'customer.company') != null)) {
        return _.filter(this.model.customer.company.contacts, c => c.send_reservation_orders_ind);
      } else {
        return this.model.customer.contact;
      }
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "50%";
      }else{
        return "100%"
      }

    },
    editionMode(){
      return this.edit!=null;
    },
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
    ...mapGetters(['isAutomaticDelayOnReservationActivated']),

	},
  mounted(){
    this.fetchAdminUsers();
  },
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';
.notSelectable {
  cursor: default;

}
.selectable {
  cursor: pointer;

  &:hover {
    //margin: 15px -20px;
    //padding: 10px;
    background-color: lighten($background-color, 20%);
    border-radius: 5px;
    box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

  }
}

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
